module.exports = __webpack_public_path__ + "static/media/752MeldrumStNW_2018-06-18_121.386391da.jpg";